import EventEmitter from 'events';
import { v4 } from 'uuid';

type SeverityType = 'info' | 'error' | 'warning';

export type NotificationType = {
  id: string;
  severity: SeverityType;
  message: string;
  timeout?: number;
};

export class PageStateManager extends EventEmitter {
  private notifications: NotificationType[] = [];

  getNotifications() {
    return this.notifications;
  }

  addNotification(severity: SeverityType, message: string, timeout?: number) {
    const id = v4();
    this.notifications.push({ id, severity, message });
    if (timeout) {
      setTimeout(() => this.removeNotification(id), timeout * 1000);
    }
    this.emit('update');
  }

  removeNotification(id) {
    this.notifications = this.notifications.filter(
      (notification) => notification.id !== id,
    );
    this.emit('update');
  }
}
